export const config =
    {
      rowSelection: false,
      fieldControl: false,
      pagination: false,
      columns: [
        {
          title: '产品类型',
          width: 120,
          dataIndex: 'typeCodeStr',
        },
        {
          title: '产品编码',
          width: 200,
          dataIndex: 'productId',
        },
        {
          title: '产品名称',
          width: 120,
          ellipsis: true,
          dataIndex: 'showName',
        },
        {
          title: '操作',
          dataIndex: '#',
          width: 140,
          fixed: 'right',
          render: 'actionRender'
        },
      ],
      footer: [
        {
          label: '添加标配',
          type: 'primary',
          events: ['onClick:onAdd'],
        }
      ],
    }